<template>
  <el-button
    v-if="_show"
    :type="type"
    :size="size"
    :icon="icon"
    :nativeType="nativeType"
    :loading="loading"
    :plain="plain"
    :autofocus="autofocus"
    :round="round"
    :circle="circle"
    :disabled="disabled"
    :class="!type||type=='default'?'normal':type"
    @click="handleClick">
    <slot></slot>
  </el-button>
</template>
<script>
export default {
  props: {
    name: 'PlButton',
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean,
    code:String
  },
  computed: {

    _show() {
      var code = this.code;
      if(!code){
        return true;
      }
      var userInfo = this.$store.state.sharing.userInfo;
      var userType = userInfo.userType;
      var codes = code.split(',');
      var hasPermission = userType==1 || false;
      if(!hasPermission){
        for(var i=0;i<codes.length;i++){
          var code = codes[i];
          if(code.charAt(0)==userType){
            hasPermission = true;
            break;
          }
        }
      }
      if(!hasPermission){
        return false;
      }
      
      var btns = userInfo.attrs.btns || [];
      var isAdmin = userInfo.attrs.isAdmin && userType == 1 || false;
      var hasPermission = isAdmin || codes.length==0;

      if (!hasPermission) {
        for (var i = 0; i < btns.length; i++) {
          for(var j=0;j<codes.length;j++){
            var code = codes[j]; 
            if (code == btns[i]) {
              hasPermission = true;
              break;
            }
          }
        }
      }

      console.log(hasPermission);
      return true;
    }
  },

  methods: {

    handleClick(evt) {
    this.$emit('click', evt);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/button.vue